import React from "react";
import { Container, Accordion } from "react-bootstrap";
import { motion } from "framer-motion";
import bgImage from "../assets/optFAQ.png";

const FAQ = () => {
  // Custom CSS to override Bootstrap accordion rounded corners
  const customStyles = `
    .accordion-button {
      border-radius: 0 !important;
    }
    .accordion-button:not(.collapsed) {
      background-color: #fff !important;
      color: #003366 !important;
      border-radius: 0 !important;
    }
    .accordion-button:focus {
      box-shadow: none !important;
      border-color: transparent !important;
    }
    .accordion-item {
      border-radius: 0 !important;
    }
    .accordion-collapse {
      border-radius: 0 !important;
    }
  `;
  const professionalStyles = {
    heroSection: {
      background: `linear-gradient(rgba(0, 31, 63, 0.85), rgba(0, 51, 102, 0.85)), url(${bgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      padding: "100px 50px",
      marginBottom: "80px",
    },
    heroTitle: {
      fontSize: "3.5rem",
      fontWeight: "700",
      letterSpacing: "-0.5px",
      marginBottom: "25px",
      color: "#fff",
      textTransform: "uppercase",
      textAlign: "center",
    },
    heroText: {
      fontSize: "1.2rem",
      maxWidth: "800px",
      margin: "0 auto",
      lineHeight: "1.8",
      fontWeight: "300",
      color: "#fff",
      textAlign: "center",
    },
    contentSection: {
      paddingBottom: "80px",
      background: "#fff",
    },
    accordionItem: {
      border: "none",
      borderLeft: "4px solid #003366",
      marginBottom: "20px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
      borderRadius: "0",
      overflow: "hidden",
    },
    accordionHeader: {
      background: "#fff",
      borderRadius: "0",
      fontWeight: "700",
      fontSize: "1.1rem",
      color: "#003366",
      padding: "0",
    },
    accordionButton: {
      borderRadius: "0",
      padding: "20px 25px",
      fontSize: "1.1rem",
      fontWeight: "700",
      color: "#003366",
      background: "#fff",
      border: "none",
      textAlign: "left",
      transition: "all 0.3s ease",
    },
    accordionBody: {
      background: "#f8f9fa",
      padding: "25px",
      fontSize: "1.05rem",
      lineHeight: "1.8",
      color: "#555",
      borderRadius: "0",
    },
  };

  const faqs = [
    {
      question: "What types of investment does Optwise Group invest in?",
      answer:
        "We specialize in stocks, bonds, and exchange-traded funds (ETFs), focusing on high-performing assets that deliver strong, consistent returns for our investors. Our diversified portfolio approach ensures balanced risk management while maximizing potential returns.",
    },
    {
      question: "How does Optwise Group minimize investment risks?",
      answer:
        "Our expert team employs rigorous due diligence processes, carefully selects investment types, and ensures strategic portfolio management. We utilize advanced risk assessment tools and maintain strict compliance standards, thus significantly reducing financial risks for our investors.",
    },
    {
      question: "Can I invest with Optwise Group as a beginner?",
      answer:
        "Absolutely! We provide tailored investment solutions for both new and experienced investors. Our team guides you through every step of the investment process with expert insights, educational resources, and personalized support to help you build confidence and make informed decisions.",
    },
    {
      question: "How are returns generated from my investment?",
      answer:
        "Returns are generated through multiple channels including capital appreciation, dividend distributions, interest payments, and long-term portfolio growth. Our investment strategies are designed to optimize returns while maintaining appropriate risk levels aligned with your investment objectives.",
    },
    {
      question:
        "What makes Optwise Group different from other investment firms?",
      answer:
        "We distinguish ourselves through our proven track record of high-performing investment funds, an expert internal management team with decades of experience, and a responsible, long-term investment approach that considers both financial returns and sustainable impact. Our commitment to transparency, compliance, and client service sets us apart in the industry.",
    },
    {
      question: "How can I get started with Optwise Group?",
      answer:
        "Getting started is simple. Contact us through our website contact form, call our office at 02 9052 0803, or email us at Admin@optwisegroup.com.au. We'll schedule a consultation to understand your investment goals and guide you through the onboarding process with personalized recommendations.",
    },
    {
      question: "What is the minimum investment amount?",
      answer:
        "Minimum investment amounts vary depending on the fund type and investment structure. Please contact our team for specific details about investment minimums for different fund options and to discuss which investment vehicle best suits your financial situation.",
    },
    {
      question: "How often will I receive updates on my investment?",
      answer:
        "We provide regular portfolio updates including quarterly performance reports, annual statements, and real-time access to your investment dashboard. Our team is also available for scheduled reviews and consultations to discuss your portfolio performance and any adjustments needed.",
    },
  ];

  return (
    <div style={{ background: "#fff" }}>
      <style>{customStyles}</style>
      {/* Hero Section */}
      <motion.div
        style={professionalStyles.heroSection}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <motion.h1
          style={professionalStyles.heroTitle}
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          Frequently Asked Questions
        </motion.h1>
        <motion.p
          style={professionalStyles.heroText}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Find answers to common questions about our investment services,
          processes, and how we can help you achieve your financial goals.
        </motion.p>
      </motion.div>

      {/* FAQ Content Section */}
      <Container style={professionalStyles.contentSection}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Accordion defaultActiveKey="0">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
              >
                <Accordion.Item
                  eventKey={index.toString()}
                  style={professionalStyles.accordionItem}
                >
                  <Accordion.Header style={professionalStyles.accordionHeader}>
                    <span style={{ fontWeight: "700", fontSize: "1.1rem" }}>
                      {faq.question}
                    </span>
                  </Accordion.Header>
                  <Accordion.Body style={professionalStyles.accordionBody}>
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              </motion.div>
            ))}
          </Accordion>
        </motion.div>

        {/* Additional Help Section */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          style={{
            marginTop: "60px",
            padding: "40px",
            background: "#f8f9fa",
            borderLeft: "4px solid #003366",
            boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
          }}
        >
          <h3
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              color: "#003366",
              marginBottom: "20px",
              textTransform: "uppercase",
              letterSpacing: "-0.5px",
            }}
          >
            Still Have Questions?
          </h3>
          <p
            style={{
              fontSize: "1.1rem",
              lineHeight: "1.8",
              color: "#555",
              marginBottom: "25px",
            }}
          >
            Our team is here to help. If you couldn't find the answer you were
            looking for, please don't hesitate to reach out to us directly.
          </p>
          <a
            href="/contact"
            style={{
              display: "inline-block",
              background: "#003366",
              color: "#fff",
              padding: "15px 40px",
              fontSize: "1.1rem",
              fontWeight: "600",
              letterSpacing: "0.5px",
              textTransform: "uppercase",
              textDecoration: "none",
              border: "2px solid #003366",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#fff";
              e.target.style.color = "#003366";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "#003366";
              e.target.style.color = "#fff";
            }}
          >
            Contact Us
          </a>
        </motion.div>
      </Container>
    </div>
  );
};

export default FAQ;
